module.exports = __webpack_public_path__ + "static/media/bg.0dedf74b.svg";